import { Box, SxProps } from '@mui/material';
import { FC, PropsWithChildren } from 'react';
import { colors } from '~/theme';

interface PageProps {
  innerWrapperSx?: SxProps;
}

export const Page: FC<PropsWithChildren<PageProps>> = ({ children, innerWrapperSx: sx }) => {
  return (
    <Box display="flex" sx={{ background: colors.offWhite, width: '100vw' }} minHeight="calc(100vh - 110px)">
      <Box sx={{ maxWidth: '800px', margin: 'auto', py: { xs: 2, md: 8 }, px: { xs: 1, md: 0 }, ...sx }}>
        <Box sx={{ borderRadius: 2, overflow: 'hidden', boxShadow: 3 }}>
          <Box
            sx={{
              textAlign: 'center',
              background: colors.white,
              paddingX: { xs: 2, md: 18 },
              paddingY: { xs: 4, md: 8 },
            }}
          >
            {children}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
